const INDEXED_DB_ERROR_NAMES = new Set([
    'DatabaseClosedError',
    'MissingAPIError',
    'UnknownError',
    'AbortError',
    'InvalidStateError',
]);
const INDEXED_DB_MESSAGE_PATTERNS = [
    /cursor that doesn't exist/i,
    /IndexedDB/i,
    /Dexie/i,
    /DatabaseClosed/i,
    /MissingAPI/i,
];
/**
 * True when an offline GraphQL failure looks like IndexedDB/Dexie flaking
 * (closed DB, missing API, aborted/unknown DOMException, etc.).
 */
export default function isIndexedDBError(error) {
    if (error == null || (typeof error !== 'object' && typeof error !== 'string')) {
        return false;
    }
    const name = typeof error === 'object' && error !== null && 'name' in error
        ? String(error.name ?? '')
        : '';
    const message = typeof error === 'string'
        ? error
        : typeof error === 'object' &&
            error !== null &&
            'message' in error &&
            error.message != null
            ? String(error.message)
            : '';
    if (name && INDEXED_DB_ERROR_NAMES.has(name)) {
        return true;
    }
    return INDEXED_DB_MESSAGE_PATTERNS.some(pattern => pattern.test(message));
}
